<template>
  <div class="w1200 contract-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">上传帮扶四件套</div>
    <div class="sub-title" v-if="crowdfundingTitle">招股：{{ crowdfundingTitle }}（{{ issueNumber }}）</div>

    <el-form v-loading="loading" ref="form" :model="form" :rules="rules" label-width="140px" class="contract-form">
      <!-- 用户信息 -->
      <div class="section">
        <div class="section-title">用户信息</div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="用户名称/昵称" prop="nickname">
              <el-input v-model="form.nickname" placeholder="请输入昵称" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phoneNumber">
              <el-input v-model="form.phoneNumber" placeholder="请输入手机号" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="真实姓名" prop="identityCardName">
              <el-input v-model="form.identityCardName" placeholder="请输入真实姓名" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="identityCardNo">
              <el-input v-model="form.identityCardNo" placeholder="请输入身份证号" maxlength="18"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 帮扶合同模板 -->
      <div class="section">
        <div class="section-title">帮扶合同</div>
        <el-form-item label="合同模板">
          <el-button type="primary" plain icon="el-icon-download" @click="downloadTemplate">下载《缩水网帮扶实体投注站合同》模板</el-button>
          <span class="form-tip">下载打印后签名、按手印，再拍照或扫描上传</span>
        </el-form-item>
      </div>

      <!-- 四件套上传 -->
      <div class="section">
        <div class="section-title">四件套材料上传</div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="帮扶实战方案" prop="practicalSchemes">
              <el-upload
                class="contract-uploader"
                accept=".txt"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="(f) => onFileChange(f, 'practicalSchemes')"
                :disabled="uploading.practicalSchemes">
                <div v-if="form.practicalSchemes" class="file-preview">
                  <i class="el-icon-document"></i>
                  <span class="file-name">{{ schemeFileName || '方案.txt' }}</span>
                  <el-button type="text" @click.stop="previewScheme">查看</el-button>
                  <el-button type="text" @click.stop="clearFile('practicalSchemes')">删除</el-button>
                </div>
                <div v-else class="upload-placeholder">
                  <i class="el-icon-plus"></i>
                  <div class="upload-text">上传方案（限 .txt）</div>
                  <div class="upload-sub">支持 txt 文本文件</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实战票" prop="practicalTicket">
              <el-upload
                class="contract-uploader"
                accept="image/*"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="(f) => onFileChange(f, 'practicalTicket')"
                :disabled="uploading.practicalTicket">
                <img v-if="form.practicalTicket" :src="$img(form.practicalTicket)" class="img-preview" @click.stop />
                <div v-else class="upload-placeholder">
                  <i class="el-icon-plus"></i>
                  <div class="upload-text">实战票上传</div>
                  <div class="upload-sub">支持 JPG、PNG 格式</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="承诺签名后拍照" prop="signature">
              <el-upload
                class="contract-uploader"
                accept="image/*"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="(f) => onFileChange(f, 'signature')"
                :disabled="uploading.signature">
                <img v-if="form.signature" :src="$img(form.signature)" class="img-preview" @click.stop />
                <div v-else class="upload-placeholder">
                  <i class="el-icon-plus"></i>
                  <div class="upload-text">签名后手持拍照上传</div>
                  <div class="upload-sub">支持 JPG、PNG 格式</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="签名后合同拍照" prop="contractSignature">
              <el-upload
                class="contract-uploader"
                accept="image/*"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="(f) => onFileChange(f, 'contractSignature')"
                :disabled="uploading.contractSignature">
                <img v-if="form.contractSignature" :src="$img(form.contractSignature)" class="img-preview" @click.stop="previewImg(form.contractSignature)" />
                <div v-else class="upload-placeholder">
                  <i class="el-icon-plus"></i>
                  <div class="upload-text">签名后合同上传</div>
                  <div class="upload-sub">支持 JPG、PNG 格式</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 投注站信息 -->
      <div class="section">
        <div class="section-title">投注站信息</div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="投注站地址" prop="bettingShop">
              <el-input v-model="form.bettingShop" placeholder="请输入投注站地址" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="投注站编号" prop="bettingShopNumber">
              <el-input v-model="form.bettingShopNumber" placeholder="请输入投注站编号" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 底部提示与提交 -->
      <div class="footer-tip">
        缩水网帮扶中心合同：帮扶方案、实战票、签名合同、投注站负责人手持拍照上传（按手印、签名完整清晰）。<br />
        我已充分阅读并同意《缩水网帮扶实体投注站合同》全部条款，保证所上传材料真实、合法、有效。
      </div>
      <el-form-item>
        <el-button type="primary" :loading="submitting" @click="submit">确认上传</el-button>
        <el-button @click="goBack">取消</el-button>
      </el-form-item>
    </el-form>

    <!-- 方案文本预览 -->
    <el-dialog title="帮扶实战方案预览" :visible.sync="schemePreviewVisible" width="720px">
      <div v-loading="schemePreviewLoading" class="scheme-preview">
        <pre v-if="schemeContent">{{ schemeContent }}</pre>
        <div v-else class="tip-msg">暂无内容</div>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="imgPreviewVisible" width="720px">
      <img :src="$img(imgPreviewUrl)" style="width: 100%;" alt="预览" />
    </el-dialog>
  </div>
</template>

<script>
import { uploadSignatureContract } from "@/api/apply";
import { getInfo, upLoadFile } from "@/api/common";

export default {
  name: "ContractUpload",
  data() {
    return {
      loading: false,
      submitting: false,
      crowdfundingId: null,
      crowdfundingTitle: "",
      issueNumber: "",
      contractTemplateUrl:
        process.env.VUE_APP_CONTRACT_TEMPLATE_URL || "/contract-template.docx",
      form: {
        nickname: "",
        phoneNumber: "",
        identityCardName: "",
        identityCardNo: "",
        practicalSchemes: "",
        practicalTicket: "",
        signature: "",
        contractSignature: "",
        crowdfundingId: null,
        issueNumber: "",
        bettingShop: "",
        bettingShopNumber: "",
      },
      uploading: {
        practicalSchemes: false,
        practicalTicket: false,
        signature: false,
        contractSignature: false,
      },
      schemeFileName: "",
      schemeContent: "",
      schemePreviewVisible: false,
      schemePreviewLoading: false,
      imgPreviewVisible: false,
      imgPreviewUrl: "",
      rules: {
        nickname: [{ required: true, message: "请输入用户名称/昵称", trigger: "blur" }],
        phoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" },
        ],
        identityCardName: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        identityCardNo: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[\dXx]$/, message: "身份证号码不正确", trigger: "blur" },
        ],
        practicalSchemes: [{ required: true, message: "请上传帮扶实战方案", trigger: "change" }],
        practicalTicket: [{ required: true, message: "请上传实战票", trigger: "change" }],
        signature: [{ required: true, message: "请上传承诺签名后拍照", trigger: "change" }],
        contractSignature: [{ required: true, message: "请上传签名后合同拍照", trigger: "change" }],
        bettingShop: [{ required: true, message: "请输入投注站地址", trigger: "blur" }],
        bettingShopNumber: [{ required: true, message: "请输入投注站编号", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { crowdfundingId } = this.$route.params;
      const query = this.$route.query || {};
      if (!crowdfundingId) {
        this.$message.error("缺少众筹招股ID");
        return;
      }
      this.crowdfundingId = Number(crowdfundingId);
      this.crowdfundingTitle = query.title || "";
      this.issueNumber = query.issueNumber || "";
      this.form.crowdfundingId = this.crowdfundingId;
      this.form.issueNumber = this.issueNumber;
      this.form.bettingShop = query.bettingShopAddress || "";
      this.form.bettingShopNumber = query.bettingShopNumber || "";
      this.loadUserInfo();
    },
    loadUserInfo() {
      this.loading = true;
      getInfo()
        .then((res) => {
          const data = res && res.data !== undefined ? res.data : res;
          const user = (data && data.user) || {};
          const account = user.userAccount || {};
          this.form.nickname = user.nickName || user.userName || "";
          this.form.phoneNumber = user.phonenumber || account.phoneNumber || "";
          this.form.identityCardName = account.identityCardName || "";
          this.form.identityCardNo = account.identityCardNo || "";
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push("/sttzzbfzx/my/offering");
    },
    downloadTemplate() {
      if (!this.contractTemplateUrl) {
        this.$message.info("合同模板地址尚未配置，请联系运营人员获取");
        return;
      }
      const link = document.createElement("a");
      link.href = this.contractTemplateUrl;
      link.download = "缩水网帮扶实体投注站合同.docx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onFileChange(file, field) {
      if (!file || !file.raw) return;
      const isTxt = field === "practicalSchemes";
      if (isTxt && !file.name.toLowerCase().endsWith(".txt")) {
        this.$message.warning("帮扶实战方案仅支持 .txt 文件");
        return;
      }
      if (!isTxt && !file.raw.type.startsWith("image/")) {
        this.$message.warning("请上传图片文件");
        return;
      }
      const fd = new FormData();
      fd.append("file", file.raw);
      fd.append("fileType", "contract");
      fd.append("bizId", this.crowdfundingId || "");
      if (this.issueNumber) {
        fd.append("number", this.issueNumber);
      }
      this.uploading[field] = true;
      upLoadFile("", fd)
        .then((res) => {
          const url = res && res.data && res.data.urls;
          if (!url) {
            this.$message.error("文件上传失败");
            this.uploading[field] = false;
            return;
          }
          this.form[field] = url;
          if (field === "practicalSchemes") {
            this.schemeFileName = file.name;
          }
          this.$message.success("上传成功");
          this.uploading[field] = false;
        })
        .catch(() => {
          this.$message.error("文件上传失败");
          this.uploading[field] = false;
        });
    },
    clearFile(field) {
      this.form[field] = "";
      if (field === "practicalSchemes") {
        this.schemeFileName = "";
      }
    },
    previewScheme() {
      if (!this.form.practicalSchemes) return;
      this.schemePreviewVisible = true;
      this.schemePreviewLoading = true;
      this.schemeContent = "";

      let path = this.form.practicalSchemes;
      // 后端可能返回完整 URL，仅取路径部分
      if (/^https?:\/\//i.test(path)) {
        try {
          const u = new URL(path);
          path = u.pathname + u.search;
        } catch (e) {
          // 保持原值
        }
      }
      // 去除可能重复的 /stage-api 前缀，再统一补回，保证 dev 下走 webpack proxy
      path = path.replace(/^\/stage-api\//, "/");
      if (!path.startsWith("/stage-api/")) {
        path = "/stage-api" + (path.startsWith("/") ? "" : "/") + path;
      }

      fetch(path)
        .then((r) => {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.text();
        })
        .then((text) => {
          this.schemeContent = text || "（文件内容为空）";
          this.schemePreviewLoading = false;
        })
        .catch((err) => {
          this.schemeContent = "文件读取失败：" + (err && err.message ? err.message : "");
          this.schemePreviewLoading = false;
        });
    },
    previewImg(url) {
      this.imgPreviewUrl = url;
      this.imgPreviewVisible = true;
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        uploadSignatureContract(this.form)
          .then((res) => {
            const code = res && res.code;
            if (code === 200 || code === 0) {
              this.$message.success("四件套上传成功");
              this.goBack();
            } else {
              this.$message.error((res && res.msg) || "上传失败");
              this.submitting = false;
            }
          })
          .catch(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 8px;
    border-bottom: 2px solid #347caf;
  }

  .sub-title {
    text-align: center;
    color: #666;
    font-size: 14px;
    margin-bottom: 20px;
  }
}

.contract-form {
  padding: 10px 20px;

  .section {
    margin-bottom: 24px;
    border: 1px dashed #d9ecff;
    border-radius: 8px;
    padding: 16px;
    background: #fafcff;
  }

  .section-title {
    font-size: 16px;
    font-weight: bold;
    color: #347caf;
    margin-bottom: 16px;
    padding-left: 8px;
    border-left: 4px solid #347caf;
  }
}

.form-tip {
  margin-left: 12px;
  color: #909399;
  font-size: 13px;
}

.contract-uploader {
  ::v-deep .el-upload {
    display: block;
  }

  .upload-placeholder {
    width: 100%;
    min-height: 140px;
    border: 1px dashed #c0c4cc;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #8c939d;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #409eff;
      color: #409eff;
    }

    i {
      font-size: 32px;
      margin-bottom: 8px;
    }

    .upload-text {
      font-size: 14px;
    }

    .upload-sub {
      font-size: 12px;
      margin-top: 6px;
    }
  }

  .img-preview {
    width: 100%;
    max-height: 180px;
    object-fit: contain;
    border: 1px dashed #c0c4cc;
    border-radius: 6px;
    cursor: pointer;
  }

  .file-preview {
    min-height: 140px;
    border: 1px dashed #c0c4cc;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #606266;

    i {
      font-size: 32px;
      color: #409eff;
      margin-bottom: 8px;
    }

    .file-name {
      margin-bottom: 8px;
      word-break: break-all;
      padding: 0 12px;
      text-align: center;
    }
  }
}

.footer-tip {
  color: #606266;
  font-size: 13px;
  line-height: 1.8;
  padding: 14px 16px;
  background: #f7f8fa;
  border-radius: 6px;
  margin: 24px 0 20px;
}

.scheme-preview {
  max-height: 480px;
  overflow: auto;

  pre {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 13px;
    line-height: 1.6;
    color: #333;
    background: #f7f8fa;
    padding: 12px;
    border-radius: 4px;
  }
}

.tip-msg {
  color: #898af7;
  font-weight: bold;
  padding: 14px 0;
  text-align: center;
}
</style>
